import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { PermitsV2MetaDataItemNames, Permits2PermitEntity, PermitsV2MetaDataService, NoteTypeAllItems, PermitStatusAllItems, 
         CodeValueInspectionResults, CodeValueInspectionState, Permits2RoInspectionsEntity } 
         from '../meta-data/permitsv2-meta-data.service';
import { DwMetaDataRoutingService, DwActionResult, DwMenuActionType, DwAction, DwActionType, DwMdFormActionResult, DwMdFormActionHandler,
         DwMdFormActionState, DwQueryHelper, DwModalConfig, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken } 
         from '@devwareapps/devware-cap';

@DwAction({
  keyName: 'Permits_V2_Inspection_Needed',
  display: 'Permits V2 - Inspection Needed',
  actionType: DwActionType.formAction,
  isGlobal: false,
  parentItemName: [ PermitsV2MetaDataItemNames.Permits2Permit, 
                    PermitsV2MetaDataItemNames.Permits2Inspection,
                    PermitsV2MetaDataItemNames.Permits2RoInspections ],
  defaultButtonConfig: {
    buttonClass: 'btn-sm btn-success mr-1 mt-1',
    buttonText: 'Request Inspection'
  },
  defaultSecurityConfig: { requireCanUpdate: false },
})
@Injectable()
export class PermitV2InspectionActionService implements DwMdFormActionHandler {

  constructor(
    private metaDataRoutingService: DwMetaDataRoutingService,
    private dwModalService: DwModalService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService
  ) { }

  handleAction(formActionState: DwMdFormActionState): Observable<DwActionResult> {
    const permitEntity: Permits2PermitEntity = formActionState.formApi.getFormData()
    const id: number = formActionState.data.InspectionId;
    
    const action: DwMenuActionType = id ? DwMenuActionType.edit : DwMenuActionType.add;
    
    const isAdd = (action == DwMenuActionType.add);

    const modalOptions : Partial<DwModalConfig> = {
      modalSize : DwModalSize.responsive,
      title: isAdd ? 'Request Inspection' : 'Edit Inspection'
    };

    return this.metaDataRoutingService.openAddEditViewModal(action, PermitsV2MetaDataItemNames.Permits2Inspection, id, 
                                                            { PermitId: permitEntity.PermitId }, null, null, modalOptions)
      .pipe(map(modalResult => {
        const msg = isAdd ? (modalResult.cancelled ? "No inspection requested." : "Inspection request has been made.") 
                          : (modalResult.cancelled ? "No changes made to inspection." : "Inspection updated successfully.");
        const actionResult: DwMdFormActionResult = { success: !isAdd || !modalResult.cancelled, message: msg };
        if (!modalResult.cancelled)
          this.getPermitWithInspections(permitEntity.PermitId).subscribe(updates => {
            const update = {
              Permits2roInspections: updates.Permits2roInspections,
              PermitStatusId: updates.PermitStatusId,
              AssignedToUserId: updates.AssignedToUserId,
              FollowUpDate: updates.FollowUpDate,
              FollowUpDescription: updates.FollowUpDescription
            };
            formActionState.formApi.patchFormData(update);
          });
        return actionResult;
      }));
  }
  getPermitWithInspections(permitId): Observable<Permits2PermitEntity> {
    const md = new PermitsV2MetaDataService();
    const qh = new DwQueryHelper();
    const query = md.Permits2Permit.CreateQuery()
      .AddFilterAnd(qh.filters.Equal(md.Permits2Permit.PermitId, permitId))
      .AddPrefetchPath(md.Permits2Permit.Relations.Permits2RoInspections);
    query.FieldSettings.LoadAllLookupDisplayFields = true;
    return this.dataService.executeQuerySingle(query);
  }
}
